export type Tab = "profile" | "resources";

interface TabSwitchProps {
  currentTab: Tab;
  setCurrentTab: (tab: Tab) => void;
}

export const TabSwitch = ({ currentTab, setCurrentTab }: TabSwitchProps) => {
  return (
    <div className="my-[16px] flex w-full flex-row border-b-2 border-[#E2E2E2]">
      <div
        className={`float-left w-1/4 cursor-pointer px-4 pb-2 text-left text-sm font-medium ${
          currentTab === "resources"
            ? "border-b-2 border-[#1C1C1C] text-[#1C1C1C]"
            : "text-[#777777]"
        }`}
        onClick={() => setCurrentTab("resources")}
      >
        Resources
      </div>
      <div
        className={`float-left w-1/4 cursor-pointer px-4 pb-2 text-left text-sm font-medium ${
          currentTab === "profile"
            ? "border-b-2 border-[#1C1C1C] text-[#1C1C1C]"
            : "text-[#777777]"
        }`}
        onClick={() => setCurrentTab("profile")}
      >
        Profile
      </div>
    </div>
  );
};
